module.exports = __webpack_public_path__ + "static/media/dr_mario.06565a1c.png";